import { useState } from 'react';
import { Box } from '@mui/material';
import { FloatingActionsMenu } from '@elementary/common-ui/components';
import { TestRuns } from '@elementary/common-ui/pages';
import { DEFAULT_DAYS_BACK } from '@elementary/common-ui/constants';
import useDebounce from '@elementary/common-ui/hooks/useDebounce';
import useTestRuns from './hooks/useTestRuns';
import useGroupedTestRuns from './hooks/useGroupedTestRuns';
import TestRunsExpandedRow from './components/TestRunsExpandedRow';

const TestRunsPage = () => {
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search, 500);

  const grouped = useGroupedTestRuns({ search: debouncedSearch });
  const { isGrouped } = grouped;
  const flat = useTestRuns({ search: debouncedSearch, enabled: !isGrouped });

  return (
    <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
      {grouped.groupFetchers}
      <TestRuns
        tableData={isGrouped ? grouped.tableData : flat.tableData}
        filterOptions={flat.filterOptions}
        isFetching={isGrouped ? grouped.isFetching : flat.isFetching}
        isFilterOptionsFetching={flat.isFilterOptionsFetching}
        isError={flat.isError}
        fetchNextPage={isGrouped ? undefined : flat.fetchNextPage}
        hasNextPage={isGrouped ? undefined : flat.hasNextPage}
        groupBy={grouped.groupBy}
        onGroupByChange={grouped.onGroupByChange}
        groupableColumnIds={grouped.groupableColumnIds}
        groupedData={isGrouped ? grouped.groupedData : undefined}
        expandedGroups={isGrouped ? grouped.expandedGroups : undefined}
        onGroupToggle={isGrouped ? grouped.onGroupToggle : undefined}
        onGroupScrollToBottom={
          isGrouped ? grouped.onGroupScrollToBottom : undefined
        }
        daysBack={DEFAULT_DAYS_BACK}
        search={search}
        onSearch={setSearch}
        defaultSortKey="metadata.latest_run_time"
        defaultSortDirection="desc"
        expandedRowRenderer={(rowData) => (
          <TestRunsExpandedRow rowData={rowData} />
        )}
      />
      <FloatingActionsMenu />
    </Box>
  );
};

export default TestRunsPage;
